(function() {
    'use strict';
    const logger = require('od-modules/utils/logger');
    const {default: documentUpload} = require('components/user_area/document_upload/js/main');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');
    const DOCUMENT_UPLOAD_ID = 'document-upload';
    const myTripsUtils = require('od-modules/utils/my_trips.utils');
    const tripdetailsStorageUtils = require('../modules/utils/tripdetails_storage.utils');
    const BOOKING_INFO = 'bookingInfo';

    Odigeo.Router.handlers.attachment = function(params) {
        const pageName = 'attachment';
        const $page = $('#page');
        $page.removeClass().addClass(pageName);

        const {tdo, mb} = Odigeo.Utils.parseHashParameters(params);
        let bookingID;
        let email;

        try {
            bookingID = atob(tdo).split('&')[0].split('=')[1];
            email = atob(tdo).split('&')[1].split('=')[1];
        } catch (error) {
            logger.error(error);
            Odigeo.UIElements.show404Error();
        }

        const widgetLoader = createWidgetLoader({
            documentUpload: [`document-upload`, documentUpload.factory],
        });

        $.extend(true, Odigeo.Router.eventController, Odigeo.Router.handlers.globalEventController, {
            globalEvents: {},
            viewEvents: {
                ...documentUpload.createEventsMap(`${DOCUMENT_UPLOAD_ID}`),
                'users-manager:getTripOk': 'onGetTripOk',
                'users-manager:getTripError': 'onClickBackButton',
            },
            eventHandlers: {
                onClickDoneButton() {
                    myTripsUtils.requestTrip({email: email, bookingid: bookingID});
                },
                onClickBackButton() {
                    const url = `${Odigeo.SessionScope.gpt.pageUrl}mybooking/?mb=${mb}`;
                    window.location.replace(url);
                },
                onNoBookingAttachments() {
                    Odigeo.UIElements.show404Error();
                },
                onGetTripOk(data) {
                    tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, data.bookingDetailDTO);
                    Odigeo.Router.navigate('tripdetails');
                },
            },
        });
        Odigeo.Router.eventController.execute();
        widgetLoader.get('documentUpload').execute('init', {email, bookingID});
    };
}());
